import React, { useCallback, useContext, useState } from 'react';
import { AssetTile } from '@cube3/cubicle/src/core/molecules/ReviewTools/AssetTile';
import {
  ReviewSliderBarContext,
  ReviewViewContext,
  ReviewsActiveTabContext
} from '../../ReviewTool/Context/reviewViewContext';
import { Asset } from '@cube3/common/model/schema/resources/asset';
import { useReviewApprovals } from '../Hooks/useReviewApprovals';
import { usePollReviewComments } from '../Hooks/usePollReviewComments';
import { useHistory } from 'react-router-dom';
import { useIntersectionObserver } from '@cube3/cubicle/src/core/atoms/Scrollbar/hooks/useIntersectionObserver';
import { ReviewToolContext, useReviewToolContext } from '../Context/reviewToolContext';

interface Props {
  asset: Asset;
}

export const AssetTileSmart: React.FC<Props> = React.memo((props) => {
  const { asset } = props;

  const [ref, setRef] = useState<HTMLElement>(null);
  const { reviewLink } = useContext(ReviewViewContext);
  const { setActiveComment } = useReviewToolContext();

  const visible = useIntersectionObserver(ref);

  const { approved, rejected } = useReviewApprovals(
    visible ? asset?.id : undefined,
    reviewLink?.id
  );
  const { unresolvedComments } = usePollReviewComments(
    visible ? asset?.id : undefined
  );

  const history = useHistory();
  const { activeAsset, setActiveAsset } = useContext(ReviewViewContext);
  const { setActiveTab } = useContext(ReviewsActiveTabContext);
  //for mobile clicks
  const { itemClicked } = useContext(ReviewSliderBarContext);
  const { toggleDrawingBar, setDrawnSvg } = useContext(ReviewToolContext)

  const onClick = useCallback(() => {
    setActiveAsset(asset);
    setActiveTab(0);
    setActiveComment(undefined);
    history.push(`/review/${reviewLink.token}/asset/${asset.id}`);
    itemClicked('asset');
    //clear cached drawing_svg when switching between assets
    toggleDrawingBar(false);
    setDrawnSvg('');
  }, [asset, setActiveTab, setActiveAsset, itemClicked, toggleDrawingBar, setDrawnSvg]);

  return (
    <AssetTile
      ref={setRef}
      type="asset"
      resource={visible ? asset : undefined}
      commentsCount={unresolvedComments?.length}
      onClick={onClick}
      status={approved ? 'approved' : rejected ? 'rejected' : undefined}
      active={activeAsset && activeAsset?.id === asset?.id}
    />
  );
});
